import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CorppassDetails, MyInfo, SingpassLoginMyInfo } from "../../models/polymer/MyInfo.model";
import axios from "axios";
import { API_MyInfo, API_MyInfo_AccessToken, API_RenewToken, API_Spcp_AccessToken } from "../../utils/api";
import { PolymerAxios } from "../../utils/axios";
import moment from "moment";
import { RenewToken } from "../../models/polymer/RenewToken.model";
import data from "../../../src/utils/shared/dummy.json";
import { LoginDropdownItemInterface } from "../../models/interfaces/dropdown-item.interface";
import { PolymerCrypto } from "../../utils/encryptor";
import { SingpassTypeEnum } from "../../models/enum/singpass-type.enum";
import config from "../../config";

let demoMyinfos: LoginDropdownItemInterface[] = data.singpassMyInfo;

export interface AuthenticationStates {
  isAuthenticated: boolean;
  loginUser: MyInfo; //This are used when in singpass login page. //This maybe remove in the future.
  originalLoginUser: MyInfo; // To keep the details of the original user because when user is a deputy and is representing another owner, the loginUser will be overriden.

  retrieveFromMyInfo: boolean | null;
  retrieveFromMyInfoDeclaration: boolean | null;
  myInfoData: MyInfo; //This are used when myinfo are prompt in start application page
  structureStatus: string; //To track whether login user is retaining/outgoing

  singpassToken: string | undefined;
  expiredIn: number | undefined;
  sessionTimeout: number | undefined;
  isSingPass: boolean;
  singPassType: SingpassTypeEnum | undefined;
  corpPassDetails: CorppassDetails;

  spcpName: string;
}

const initialState: AuthenticationStates = {
  isAuthenticated: false,
  loginUser: new MyInfo(),
  originalLoginUser: new MyInfo(),

  retrieveFromMyInfo: null,
  retrieveFromMyInfoDeclaration: null,
  myInfoData: new MyInfo(),
  structureStatus: "",
  
  singpassToken: undefined,
  expiredIn: undefined,
  sessionTimeout: undefined,
  isSingPass: false,
  singPassType: undefined,
  corpPassDetails: new CorppassDetails(),

  spcpName: ""
};

const AuthenticationSlice = createSlice({
  name: "Authentication Slice",
  initialState,
  reducers: {
    updateStructureStatus: (state, action: PayloadAction<string>) => {
      state.structureStatus = action.payload;
    },
    resetRetrieveFromMyInfo: (state, action: PayloadAction<boolean>) => {
      state.retrieveFromMyInfo = action.payload;
    },
    resetRetrieveFromMyInfoDeclaration: (state, action: PayloadAction<boolean>) => {
      state.retrieveFromMyInfoDeclaration = action.payload;
    },
    updateSingpassToken: (state, action: PayloadAction<string>) => {
      console.log("DEBUG - set singpass Token", action.payload);
      state.singpassToken = action.payload;
    },
    updateExpiredIn: (state, action: PayloadAction<number | undefined>) => {
      state.expiredIn = action.payload;
    },
    updateSessionTimeout: (state, action: PayloadAction<number | undefined>) => {
      state.sessionTimeout = action.payload;
    },
    updateLoginUser: (state, action: PayloadAction<MyInfo>) => {
      state.loginUser = action.payload;
    },

    resetAuthData: (state) => {
      state.isAuthenticated = false;
      state.singPassType = undefined;
      state.corpPassDetails = new CorppassDetails();
      state.loginUser = new MyInfo();
      state.spcpName = "";
      state.retrieveFromMyInfo = null;
      state.retrieveFromMyInfoDeclaration = null;
      state.myInfoData = new MyInfo();
      state.structureStatus = "";
      state.singpassToken = undefined;
      state.expiredIn = undefined;
      state.sessionTimeout = undefined;
      state.isSingPass = false;
      caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name);
        });
      });
      localStorage.clear();
      // sessionStorage.clear();
      window.localStorage.clear();
      // window.sessionStorage.clear();
      sessionStorage.removeItem("back_triggered");
      const cookies = document.cookie.split(";");
      for (const cookie of cookies) {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        const newCookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        document.cookie = newCookie;
      }
    },
    resetLocalStorage: (state) => {
      window.localStorage.clear();
    },
    resetSingPassAuthData: (state) => {
      state.loginUser = new MyInfo();
      state.spcpName = "";
      state.retrieveFromMyInfo = null;
      state.retrieveFromMyInfoDeclaration = null;
      state.myInfoData = new MyInfo();
      state.structureStatus = "";
      state.singpassToken = undefined;
      state.expiredIn = undefined;
      state.sessionTimeout = undefined;
      state.singPassType = undefined;
      state.corpPassDetails = new CorppassDetails();
    },
  },

  extraReducers: (builder) => {
    builder.addCase(authenticateUserByNRIC.fulfilled, (state, action) => {
      //This are used by normal-login.tsx in DEV and STG ENV
      state.loginUser = { ...new MyInfo(action.payload) };
      state.originalLoginUser = { ...new MyInfo(action.payload) };
      state.isAuthenticated = true;
      state.singPassType = action.payload?.login_type;
      state.corpPassDetails = {...new CorppassDetails(action.payload?.corppass_detail)}; //TODO! THIS TO BE CHANGE DYNAMICALLY BASED ON THE singpass proxy payload field 'corppass_detai' based on CorppassDetails class
    });
    builder.addCase(authenticateUserByNRIC.rejected, (state, action) => {
      //This are used by normal-login.tsx in DEV and STG ENV
      state.loginUser = { ...new MyInfo() };
      state.isAuthenticated = false;
      state.singPassType = undefined;
      state.corpPassDetails = new CorppassDetails();
    });

    builder.addCase(retrieveMyInfoByNRIC.fulfilled, (state, action) => {
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.myInfoData = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.retrieveFromMyInfo = true;
    });
    builder.addCase(retrieveMyInfoByNRIC.rejected, (state, action) => {
      state.myInfoData = { ...new MyInfo() };
      state.retrieveFromMyInfo = false;
    });
    builder.addCase(retrieveMyInfoByNRICDeclaration.fulfilled, (state, action) => {
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.myInfoData = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.retrieveFromMyInfoDeclaration = true;
    });
    builder.addCase(retrieveMyInfoByNRICDeclaration.rejected, (state, action) => {
      state.myInfoData = { ...new MyInfo() };
      state.retrieveFromMyInfoDeclaration = false;
    });

    builder.addCase(authenticateUserBySingpassToken.fulfilled, (state, action) => {
      
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.loginUser = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.originalLoginUser = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.isAuthenticated = true;
      state.isSingPass = true;
    });
    builder.addCase(authenticateUserBySingpassToken.rejected, (state, action) => {
      state.loginUser = { ...new MyInfo() };
      state.isAuthenticated = false;
      state.isSingPass = false;
    });
    builder.addCase(getSpcpName.fulfilled, (state, action) => {
      console.log("action payload",action.payload);
      console.log("action payload spcpname",action.payload.spcp_name);
      state.spcpName = action.payload.spcp_name;
      state.singPassType = action.payload.login_type ?? SingpassTypeEnum.singpass; //TODO! THIS TO BE CHANGE DYNAMICALLY BASED ON THE singpass proxy payload field 'login_type' with valud 'SP' | 'CP' from SingpassTypeEnum
      if(action.payload.corppass_detail !== ""){
        const corppassDetails = JSON.parse(action.payload.corppass_detail); 
        const corppassData = {
          uen: corppassDetails.tpentid,
        };
        state.corpPassDetails = new CorppassDetails(corppassData);
        console.log("corppassDetails",corppassDetails);
        console.log("corppassData",corppassData);
      } else {
        console.log("no corppassData");
        state.corpPassDetails = new CorppassDetails();
      }
      // state.corpPassDetails = {...new CorppassDetails(action.payload.corppass_detail)}; //TODO! THIS TO BE CHANGE DYNAMICALLY BASED ON THE singpass proxy payload field 'corppass_detai' based on CorppassDetails class
    });
    builder.addCase(getSpcpName.rejected, (state) => {
      state.spcpName = "";
      state.singPassType = undefined;
      state.corpPassDetails = new CorppassDetails();
      state.isAuthenticated = false;
    });
    builder.addCase(renewTokenForSingpassLogin.fulfilled, (state, action) => {
      if (action.payload) {
        const {code, expires_in} = action.payload as RenewToken;
        console.log("expires_in: ", expires_in);
        state.singpassToken = code;
        state.expiredIn = Math.floor(Number(expires_in)/1000);
        state.sessionTimeout = ((Number(expires_in))/1000)-300;
        // state.expiredIn = moment().add(Number(expires_in), 'milliseconds').unix();
      }
    });
    builder.addCase(renewTokenForSingpassLogin.rejected, (state, action) => {
      if(!config.isLocalhost){
        AuthenticationSlice.caseReducers.resetAuthData(state);
      }
    });
  },
});

export const { updateStructureStatus, resetAuthData, resetSingPassAuthData, resetRetrieveFromMyInfoDeclaration,updateExpiredIn, updateSessionTimeout, resetRetrieveFromMyInfo, updateSingpassToken, updateLoginUser, resetLocalStorage } = AuthenticationSlice.actions;

export default AuthenticationSlice.reducer;

//NOTE CHANGE API, DYNAMIC UINFIN
export const authenticateUserByNRIC = createAsyncThunk(
  "authenticateUserByNRIC",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { uinfin, loginOptions } = args;

    const loginDetails: LoginDropdownItemInterface | undefined = (loginOptions ?? demoMyinfos).find((e: LoginDropdownItemInterface)=> e.value === uinfin)

    const isDynamic = loginDetails?.dynamic;
    const loginType = loginDetails?.login_type as SingpassTypeEnum ?? SingpassTypeEnum.singpass;
    const uen = loginDetails?.uen ?? ""
    
    if(isDynamic ){
      return {
        uinfin: uinfin,
        name: `${uinfin}`,
        residential_status: 'C',
        dob: '1980-12-17',
        mobile_no: '00001111',
        email: 'michael-isDynamic@gmail.com',
        race: 'C',
        nationality: 'SG',
        sex: 'M',
        marital_status: "S",
        login_type: loginType,
        corppass_detail : {
          uen,
        },
      }
    }
    else{
      //Previosuly will call swagger, now are removed
    }
  }
);



const handleCreateAsyncThunk = (name: string) => createAsyncThunk(
  name,
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { uinfin, singpass_code, allow_my_info } = args;
    if (allow_my_info) {
      return await  PolymerAxios(uinfin, singpass_code)
        .get(`${API_MyInfo}`)
        .then((res) => {
          if (res.status === 200) {
            return fulfillWithValue(res.data);
          } else {
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
    } else {
      return rejectWithValue(false);
    }
  }
)


//NOTE: THIS IS ACTUAL SINGPASS LOGIN 
export const authenticateUserBySingpassToken = createAsyncThunk(
  "authenticateUserBySingpassToken",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    
      return await PolymerAxios('', singpass_code).get(`${API_MyInfo_AccessToken}`)
        .then((res) => {
          if (res.status === 200) {
            const myinfo_data:SingpassLoginMyInfo = JSON.parse(JSON.stringify(res.data));
            return fulfillWithValue(myinfo_data);
          } else {
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
   
  }
);

export const getSpcpName = createAsyncThunk(
  "getSpcpName",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    
      return await PolymerAxios('', singpass_code).get(`${API_Spcp_AccessToken}`)
        .then((res) => {
          if (res.status === 200) {
            const spcp_data = JSON.parse(JSON.stringify(res.data));
            console.log("API_Spcp_AccessToken status 200: ", spcp_data);
            console.log("API_Spcp_AccessToken status 200: ", res.data);
            return fulfillWithValue(spcp_data);
          } else {
            console.log("API_Spcp_AccessToken status failed ");
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
  }
);

export const assignNRICforSingpassLogin = createAsyncThunk(
  "assignNRICforSingpassLogin",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    return fulfillWithValue(true);
  }
);

export const renewTokenForSingpassLogin = createAsyncThunk(
  "renewTokenForSingpassLogin",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    return await PolymerAxios('',singpass_code).get(`${API_RenewToken}`).then(res=>{
      if(res.status === 200){
        return fulfillWithValue(res.data);
      }
      else if(res.status === 401){        
        return rejectWithValue(401);
      }
    }).catch((e)=>{
      return rejectWithValue(500);
    });
  }
);




export const retrieveMyInfoByNRIC = handleCreateAsyncThunk("retrieveMyInfoByNRIC");
export const retrieveMyInfoByNRICDeclaration = handleCreateAsyncThunk("retrieveMyInfoByNRICDeclaration");
